var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ck-form-item",class:{'ck-form-item-error': !_vm.checkValidity()
            ,'ck-form-item-valid': _vm.checkValidity()
            ,'ck-form-item-left': _vm.labelPosition === 'left'
            ,'ck-form-item-right': _vm.labelPosition === 'right'
            ,'ck-form-item-top': _vm.labelPosition === 'top'
        }},[(!_vm.isReadOnly)?_c('div',[(_vm.label)?_c('label',{staticClass:"ck-form-item-label",class:{'ck-form-item-label-required': _vm.required},style:({width: _vm.labelWidth})},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.isReadOnly)?_c('div',[_c('ck-informations',{attrs:{"label":_vm.label,"display":_vm.display}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0865b44f","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ck-form/ck-form-item.vue
// module id = 582
// module chunks = 0